// extracted by mini-css-extract-plugin
export var alt = "SignInBar-module--alt--39dd4";
export var closeButton = "SignInBar-module--closeButton--bf2d3";
export var desktopOnly = "SignInBar-module--desktopOnly--739dc";
export var dropdown = "SignInBar-module--dropdown--05990";
export var emailSentContainer = "SignInBar-module--email-sent-container--7edb5";
export var loginForm = "SignInBar-module--loginForm--f2e48";
export var logoIcon = "SignInBar-module--logo-icon--ed7ec";
export var main = "SignInBar-module--main--506b5";
export var mobileOnly = "SignInBar-module--mobileOnly--264f5";
export var modalContainer = "SignInBar-module--modalContainer--4554e";
export var profile = "SignInBar-module--profile--5656e";
export var profileModal = "SignInBar-module--profileModal--a79f1";
export var textLeft = "SignInBar-module--textLeft--76875";
export var travelPassLogo = "SignInBar-module--travelPassLogo--66c77";
export var visuallyHidden = "SignInBar-module--visuallyHidden--e6441";